import { type FC } from 'react'
import { CheckInCircleGradientIcon, ContactIcon, LinkAwayIcon, LinkIcon } from '../../../components/ui'
import { type ConnectToCrmWidgetData, ObjectTypes } from '@playbooks/action-cards-utils/src'
import { UnlinkIcon } from '../../../components/ui'
import getCrmObjectName from '../../../utils/getCrmObjectName'
import { useTranslation } from '../../../contexts/localization/Localization'

const ValuesList: FC<{ widget: ConnectToCrmWidgetData; disconnectWidget: () => void }> = ({
  widget,
  disconnectWidget,
}) => {
  const { text: t } = useTranslation()

  return (
    <>
      <div className={`flex items-center border-b pb-5`}>
        <div className={`text-xl mr-1`}>
          <LinkIcon />
        </div>
        <div className="font-semibold dark:text-white">{t('connectedToCrm')}</div>{' '}
        <span className="text-[#969696] ml-1">({widget.crmSystem})</span>
        <button
          type="button"
          className={
            'flex ml-auto h-4.75 px-2 items-center rounded-4xl text-[10px] text-white bg-[#7D7D7D] hover:bg-black dark:hover:bg-white  dark:hover:text-black'
          }
          onClick={disconnectWidget}
        >
          <div className={`text-[12px]`}>
            <UnlinkIcon />
          </div>
          <span className="ml-1">{t('disconnectFromCrm')}</span>
        </button>
      </div>
      <ul className={`mt-2`}>
        {widget.value?.map((val, i) => {
          const type = getCrmObjectName(val.type)
          const nameWithUppercaseFirstLetter = type[0].toUpperCase() + type.slice(1)

          return (
            <li key={i} className="flex items-center py-1.25 dark:text-white">
              <div className="text-[14px] mr-2 flex items-center relative -top-px text-[#0F6ABD]">
                {val.type === ObjectTypes.Contact ? (
                  <div className={`text-[15px]`}>
                    <ContactIcon />
                  </div>
                ) : (
                  <CheckInCircleGradientIcon />
                )}
              </div>
              <span className={`mr-1 font-bold`}>{nameWithUppercaseFirstLetter}:</span>
              <span>
                {val.name}
                {val.email ? ` - ${val.email}` : ''}
              </span>
              <a href={val.url} target="_blank" className={'hover:underline text-[#7F7F7F] text-[14px] ml-2'}>
                <LinkAwayIcon />
              </a>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default ValuesList
